<template src="./Services.html"></template>

<script>
import Form from 'components/form/Form';
import { onWaypoint, parallax } from 'src/mixins';

export default {
  mixins: [onWaypoint, parallax],
  components: {
    Form,
  },
};
</script>

<style lang="scss">
@import "~styles/vars.scss";
@import "~styles/portfolio.scss";
.services_content{
  margin-top: 0;
  overflow: hidden;

  @media only screen and (max-width : $phone){
    margin-top: 18.75vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/services/Services.vue